import { createWebHistory, createRouter } from "vue-router";
import Main from "./layout/Main.vue";
import { GetToken, TYPE_USER_TOKEN } from "./utils/token_manager";
import { name } from "dayjs/locale/zh-cn";

export const MainRoute = [
    {
        path: "/home",
        name: "Home",
        component: Main,
        meta: {
            title: "首页",
            icon:  "HomeOutlined",
        },
        children: [
            {
                path: "index",
                name: "Index",
                sensitive: true,
                component: () => import("./views/home/Index.vue"),
                alias: ["/home", "/index", "/"],
                meta: {
                    title:  "控制台",
                    parent: "Home",
                }
            }
        ],
    },
    {
        path: "/user",
        name: "User",
        component: Main,
        meta: {
            title: "用户管理",
            icon: "TeamOutlined",
        },
        children: [
            {
                name: "UserList",
                path: "user-list",
                sensitive: true,
                component: () => import("./views/user/UserList.vue"),
                meta: {
                    title: "用户列表",
                    parent: "User",
                },
                children: [ //三级菜单为跳转按钮
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "UserList",
                        },
                    },
                    {
                        name: "BtnBalanceList",
                        path: "",
                        meta: {
                            title: "流水记录按钮",
                            parent: "UserList",
                        },
                    },
                    {
                        name: "BtnOrderList",
                        path: "",
                        meta: {
                            title: "订单记录按钮",
                            parent: "UserList",
                        },
                    },
                    {
                        name: "BtnUserDetail",
                        path: "",
                        meta: {
                            title: "用户详情按钮",
                            parent: "UserList",
                        },
                    },
                    {
                        name: "BtnToBlacklist",
                        path: "",
                        meta: {
                            title: "加黑名单按钮",
                            parent: "UserList",
                        },
                    },
                ]
            },
            {
                name: "BalanceList",
                path: "balance-list",
                sensitive: true,
                component: () => import("./views/user/BalanceList.vue"),
                meta: {
                    title: "用户流水",
                    parent: "User",
                },
            },
            {
                name: "SmsList",
                path: "sms-list",
                sensitive: true,
                component: () => import("./views/user/SmsList.vue"),
                meta: {
                    title: "短信列表",
                    parent: "User",
                },
            },
        ],
    },
    {
        path: "/finance",
        name: "Finance",
        component: Main,
        meta: {
            title: "财务管理",
            icon: "TransactionOutlined",
        },
        children: [
            {
                name: "ChargeList",
                path: "charge-list",
                sensitive: true,
                component: () => import("./views/finance/ChargeList.vue"),
                meta: {
                    title: "充值管理",
                    parent: "Finance",
                },
            },
            {
                name: "WithdrawList",
                path: "withdraw-list",
                sensitive: true,
                component: () => import("./views/finance/WithdrawTabs.vue"),
                meta: {
                    title: "提现管理",
                    parent: "Finance",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "WithdrawList",
                        },
                    },
                    {
                        name: "BtnAuditPass",
                        path: "",
                        meta: {
                            title: "审核通过按钮",
                            parent: "WithdrawList",
                        },
                    },
                    {
                        name: "BtnAuditFail",
                        path: "",
                        meta: {
                            title: "审核驳回按钮",
                            parent: "WithdrawList",
                        },
                    },
                    {
                        name: "BtnReceiptDetail",
                        path: "",
                        meta: {
                            title: "查看回执按钮",
                            parent: "WithdrawList",
                        },
                    },
                ]
            },
        ],
    },
    {
        path: "/award",
        name: "Award",
        component: Main,
        meta: {
            title: "宾果管理",
            icon:  "ShoppingOutlined",
        },
        children: [
            {
                name: "LotteryList",
                path: "lottery-list",
                sensitive: true,
                component: () => import("./views/award/LotteryList.vue"),
                meta: {
                    title:  "开奖列表",
                    parent: "Award",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "LotteryList",
                        },
                    },
                    {
                        name: "BtnManualLottery",
                        path: "",
                        meta: {
                            title: "手动开奖按钮",
                            parent: "LotteryList",
                        },
                    }
                ]
            },
            {
                name: "OrderList",
                path: "order-list",
                props: true,
                sensitive: true,
                component: () => import("./views/award/OrderList.vue"),
                meta: {
                    title:  "下注列表",
                    parent: "Award",
                }
            },
            {
                path: "odds-settings",
                name: "OddsSettings",
                sensitive: true,
                component: () => import("./views/award/OddsList.vue"),
                meta: {
                    title: "赔率设置",
                    parent: "Award",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "OddsSettings",
                        },
                    },
                    {
                        name: "BtnUpdateOdds",
                        path: "",
                        meta: {
                            title: "更新赔率按钮",
                            parent: "OddsSettings",
                        },
                    },
                ]
            },
        ],
    },
    {
        path: "/Binary",
        name: "Binary",
        component: Main,
        meta: {
            title: "二元管理",
            icon:  "CodeOutlined",
        },
        children: [
            {
                name: "BinaryLotteryList",
                path: "binary-lottery-list",
                sensitive: true,
                component: () => import("./views/binary/LotteryList.vue"),
                meta: {
                    title:  "开奖列表",
                    parent: "Binary",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "LotteryList",
                        },
                    }
                ]
            },
            {
                name: "BinaryOrderList",
                path: "binary-order-list",
                props: true,
                sensitive: true,
                component: () => import("./views/binary/OrderList.vue"),
                meta: {
                    title:  "下注列表",
                    parent: "Binary",
                },
            },
            {
                name: "BinaryConfigList",
                path: "binary-config-list",
                sensitive: true,
                component: () => import("./views/binary/ConfigList.vue"),
                meta: {
                    title: "配置列表",
                    parent: "Binary",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "BinaryConfigList",
                        },
                    },
                ],
            }
        ],
    },
    {
        path: "/game",
        name: "Game",
        component: Main,
        meta: {
            title: "游戏管理",
            icon:  "ShoppingOutlined",
        },
        children: [
            {
                name: "GameList",
                path: "game-list",
                sensitive: true,
                component: () => import("./views/game/GameList.vue"),
                meta: {
                    title: "游戏列表",
                    parent: "Game",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "GameList",
                        },
                    },
                ],
            },
            {
                name: "GameRecordList",
                path: "game-record-list",
                sensitive: true,
                component: () => import("./views/game/GameRecordList.vue"),
                meta: {
                    title:  "记录列表",
                    parent: "Game",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "GameRecordList",
                        },
                    }
                ]
            },
            
        ],
    },
    {
        path: "/invite",
        name: "Invite",
        component: Main,
        meta: {
            title: "运营数据",
            icon: "TransactionOutlined",
        },
        children: [
            {
                path: "dailyReport",
                name: "InviteDailyReport",
                sensitive: true,
                component: () => import("./views/invite/dailyReport.vue"),
                meta: {
                    title: "邀请日报",
                    parent: "Invite",
                }
            },
            {
                path: "transfer",
                name: "transfer",
                sensitive: true,
                component: () => import("./views/invite/transfer.vue"),
                meta: {
                    title: "划转记录",
                    parent: "Invite",
                }
            }
        ]
    },
    {
        path: "/channel",
        name: "Channel",
        component: Main,
        meta: {
            title: "渠道管理",
            icon: "ShoppingOutlined",
        },
        children: [
            {
                path: "list",
                name: "ChannelList",
                sensitive: true,
                component: () => import("./views/channel/ChannelList.vue"),
                meta: {
                    title: "渠道列表",
                    parent: "Channel",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "ChannelList",
                        },
                    },
                    {
                        name: "BtnAddChannel",
                        path: "",
                        meta: {
                            title: "新增按钮",
                            parent: "ChannelList",
                        },
                    },
                    {
                        name: "BtnEdit",
                        path: "",
                        meta: {
                            title: "编辑按钮",
                            parent: "ChannelList",
                        },
                    },
                    {
                        name: "BtnDelete",
                        path: "",
                        meta: {
                            title: "删除按钮",
                            parent: "ChannelList",
                        },
                    },
                ]
            },
            {
                path: "stats",
                name: "ChannelStats",
                sensitive: true,
                component: () => import("./views/channel/ChannelStats.vue"),
                meta: {
                    title: "渠道数据",
                    parent: "Channel",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "ChannelStats",
                        },
                    },
                ]
            },
            {
                path: "statistics",
                name: "ChannelStatistics",
                sensitive: true,
                component: () => import("./views/channel/ChannelStatistics.vue"),
                meta: {
                    title: "渠道统计",
                    parent: "Channel",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "ChannelStatistics",
                        },
                    },
                ]
            },
        ],
    },
    {
        path: "/config",
        name: "Config",
        component: Main,
        meta: {title: "配置管理", icon: "SettingOutlined"},
        children: [
            // {
            //     path: "paychannel",
            //     name: "PayChannel",
            //     sensitive: true,
            //     component: () => import("./views/config/PayChannelList.vue"),
            //     meta: {
            //         title: "支付通道",
            //         parent: "Config",
            //     },
            //     children: [
            //         {
            //             name: "ViewPage",
            //             path: "",
            //             meta: {
            //                 title: "列表页面",
            //                 parent: "PayChannel",
            //             },
            //         },
            //         {
            //             name: "BtnAddChannel",
            //             path: "",
            //             meta: {
            //                 title: "添加通道按钮",
            //                 parent: "PayChannel",
            //             },
            //         },
            //         {
            //             name: "BtnSetStatus",
            //             path: "",
            //             meta: {
            //                 title: "启用/禁用按钮",
            //                 parent: "PayChannel",
            //             },
            //         },
            //         {
            //             name: "BtnEdit",
            //             path: "",
            //             meta: {
            //                 title: "编辑按钮",
            //                 parent: "PayChannel",
            //             },
            //         },
            //     ]
            // },
            {
                path: "paytype",
                name: "PayType",
                sensitive: true,
                component: () => import("./views/config/PayTypeList.vue"),
                meta: {
                    title: "支付类型",
                    parent: "Config",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "PayType",
                        },
                    },
                    {
                        name: "BtnAddPayType",
                        path: "",
                        meta: {
                            title: "添加支付类型按钮",
                            parent: "PayType",
                        },
                    },
                    {
                        name: "BtnSetStatus",
                        path: "",
                        meta: {
                            title: "启用/禁用按钮",
                            parent: "PayType",
                        },
                    },
                    {
                        name: "BtnEdit",
                        path: "",
                        meta: {
                            title: "编辑按钮",
                            parent: "PayType",
                        },
                    },
                ]
            },
            {
                path: "payaccount",
                name: "PayAccount",
                sensitive: true,
                component: () => import("./views/config/PayAccountList.vue"),
                meta: {
                    title: "支付账户",
                    parent: "Config",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "PayAccount",
                        },
                    },
                    {
                        name: "BtnDefaultPay",
                        path: "",
                        meta: {
                            title: "设为代付按钮",
                            parent: "PayAccount",
                        },
                    },
                    {
                        name: "BtnEdit",
                        path: "",
                        meta: {
                            title: "编辑按钮",
                            parent: "PayAccount",
                        },
                    },
                ]
            },
            // {
            //     path: "odds",
            //     name: "OddsSettings",
            //     sensitive: true,
            //     component: () => import("./views/config/OddsList.vue"),
            //     meta: {
            //         title: "赔率设置",
            //         parent: "Config",
            //     },
            //     children: [
            //         {
            //             name: "ViewPage",
            //             path: "",
            //             meta: {
            //                 title: "列表页面",
            //                 parent: "OddsSettings",
            //             },
            //         },
            //         {
            //             name: "BtnUpdateOdds",
            //             path: "",
            //             meta: {
            //                 title: "更新赔率按钮",
            //                 parent: "OddsSettings",
            //             },
            //         },
            //     ]
            // },
            {
                path: "configs",
                name: "ConfigSettings",
                sensitive: true,
                component: () => import("./views/config/ConfigList.vue"),
                meta: {
                    title: "配置设置",
                    parent: "Config",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "ConfigSettings",
                        },
                    },
                    {
                        name: "BtnAddConfig",
                        path: "",
                        meta: {
                            title: "添加配置按钮",
                            parent: "ConfigSettings",
                        },
                    },
                    {
                        name: "BtnEdit",
                        path: "",
                        meta: {
                            title: "编辑按钮",
                            parent: "ConfigSettings",
                        },
                    },
                    {
                        name: "BtnDelete",
                        path: "",
                        meta: {
                            title: "删除按钮",
                            parent: "ConfigSettings",
                        },
                    },
                ]
            },
            {
                path: "banner",
                name: "BannerSettings",
                sensitive: true,
                component: () => import("./views/config/BannerList.vue"),
                meta: {
                    title: "banner设置",
                    parent: "Config",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "BannerSettings",
                        },
                    },
                    {
                        name: "BtnAddBanner",
                        path: "",
                        meta: {
                            title: "新增按钮",
                            parent: "BannerSettings",
                        },
                    },
                    {
                        name: "BtnEdit",
                        path: "",
                        meta: {
                            title: "编辑按钮",
                            parent: "BannerSettings",
                        },
                    },
                    {
                        name: "BtnDelete",
                        path: "",
                        meta: {
                            title: "删除按钮",
                            parent: "BannerSettings",
                        },
                    },
                ]
            },
            {
                path: "notice",
                name: "NoticeSettings",
                sensitive: true,
                component: () => import("./views/config/NoticeList.vue"),
                meta: {
                    title: "公告配置",
                    parent: "Config",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "NoticeSettings",
                        },
                    },
                    {
                        name: "BtnAddNotice",
                        path: "",
                        meta: {
                            title: "新增按钮",
                            parent: "NoticeSettings",
                        },
                    },
                    {
                        name: "BtnEdit",
                        path: "",
                        meta: {
                            title: "编辑按钮",
                            parent: "NoticeSettings",
                        },
                    },
                    {
                        name: "BtnDelete",
                        path: "",
                        meta: {
                            title: "删除按钮",
                            parent: "NoticeSettings",
                        },
                    },
                ]
            },
            {
                path: "version",
                name: "VersionSettings",
                sensitive: true,
                component: () => import("./views/config/VersionList.vue"),
                meta: {
                    title: "版本设置",
                    parent: "Config",
                },
                children: [
                    {
                        name: "ViewPage",
                        path: "",
                        meta: {
                            title: "列表页面",
                            parent: "VersionSettings",
                        },
                    },
                    {
                        name: "BtnCreateVersion",
                        path: "",
                        meta: {
                            title: "创建版本按钮",
                            parent: "VersionSettings",
                        },
                    },
                    {
                        name: "BtnUpdateVersion",
                        path: "",
                        meta: {
                            title: "更新版本按钮",
                            parent: "VersionSettings",
                        },
                    },
                ]
            },
            {
                path: "Messages",
                name: "MessagesSettings",
                sensitive: true,
                component: () => import("./views/config/MessageList.vue"),
                meta: {
                    title: "系统消息",
                    parent: "Config",
                },
            },
        ],
    },
    {
        path: "/admin",
        name: "Admin",
        component: Main,
        meta: {
            title: "管理员",
            icon: "AuditOutlined",
        },
        children: [
            {
                path: "settings",
                name: "AdminSettings",
                sensitive: true,
                component: () => import("./views/admin/AdminSettings.vue"),
                meta: {
                    title: "账户设置",
                    parent: "Admin",
                },
            },
            {
                path: "admin-list",
                name: "AdminList",
                sensitive: true,
                component: () => import("./views/admin/AdminList.vue"),
                meta: {
                    title: "人员管理",
                    parent: "Admin",
                },
            },
        ],
    },
    {
        path: "/",
        name: "hidden",
        meta:{ title:'其他' },
        children: [
            {
                path: "logout",
                name: "Logout",
                component: () => import("./layout/Login.vue"),
            },
            {
                path: "login",
                name: "Login",
                component: () => import("./layout/Login.vue"),
            },
            {
                path: "not-found",
                name: "NotFound",
                component: () => import("./layout/NotFound.vue"),
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes: MainRoute,
});
router.beforeEach((to, from, next) => {
    if (to.name == "Logout") {
        localStorage.clear();
        sessionStorage.clear();
        return next();
    }
    let token = GetToken(TYPE_USER_TOKEN);
    if (to.name != "Login" && !token) {
        return next({ name: "Login" });
    } else {
        if (to.name == "Login" && token) {
            return next({ name: "Index" });
        } else {
            return next();
        }
    }
});

export default router;
